class UtilService {
    public generateGuid(): string {
        return 'lxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[lxy]/g, c => {
            let l = (Math.random() * 6 + 10) | 0; // limit first char to letters only
            let r = (Math.random() * 16) | 0;
            let v = c === 'l' ? l : c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }
}

export const utilService = new UtilService();
